module.exports = __webpack_public_path__ + "static/media/6.dbea6433.svg";